// src/services/slideService.js
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import { db } from "../auth/auth";

const slidesRef = collection(db, "slides");

/**
 * Get all slides for a deck (ordered)
 */
export async function getSlidesByDeck(deckId, ownerId) {
  if (!deckId || !ownerId) {
    throw new Error("deckId or ownerId missing");
  }

  const q = query(
    collection(db, "slides"),
    where("deckId", "==", deckId),
    where("ownerId", "==", ownerId),
    orderBy("order", "asc")
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
}

/**
 * Create a slide (used by createDeck in deckService)
 */
export async function createSlide({ deckId, ownerId, order = 1000 }) {
  const now = Date.now();

  const docRef = await addDoc(slidesRef, {
    deckId,
    ownerId,
    order,
    elements: [],
    style: {
      background: "#ffffff",
    },
    createdAt: now,
    updatedAt: now,
  });

  return {
    id: docRef.id,
    deckId,
    ownerId,
    order,
    elements: [],
    style: {
      background: "#ffffff",
    },
    createdAt: now,
    updatedAt: now,
  };
}


/**
 * Get single slide
 */
export async function getSlideById(slideId) {
  const slideRef = doc(db, "slides", slideId);
  const snap = await getDoc(slideRef);

  if (!snap.exists()) return null;

  return {
    id: snap.id,
    ...snap.data(),
  };
}

/**
 * Update entire elements array (drag / resize / reorder / zIndex)
 */
export async function updateSlideElements(slideId, elements) {
  const slideRef = doc(db, "slides", slideId);

  await updateDoc(slideRef, {
    elements,
    updatedAt: Date.now(),
  });
}

/**
 * Update slide style (background, etc.)
 */
export async function updateSlideStyle(slideId, style) {
  const slideRef = doc(db, "slides", slideId);

  await updateDoc(slideRef, {
    style,
    updatedAt: Date.now(),
  });
}

/**
 * Delete a slide
 */
export async function deleteSlide(slideId) {
  const slideRef = doc(db, "slides", slideId);
  await deleteDoc(slideRef);
}
